import React from 'react'
import '../styles/Home.css';
import { GrCode } from "react-icons/gr";
import { useTypewriter, Cursor} from 'react-simple-typewriter';

export default function Home() {

  const [text, count] = useTypewriter({
    words: [ "console.log('Hi there!')",'cout<<"Hello";',"print('Hello...')"],
    loop: 0, 
    typeSpeed: 100,
    deleteSpeed: 60,
    delaySpeed: 1000,
    cursor:false
    })

  return (
    <div id = "home" className="HomeContainer">
      <div className="HomeTextContainer">
        <div className='HomeContainerLeft'>
          <GrCode className='HomeCodeIcon' size = '22em'/>
        </div>
        <div className='HomeContainerRight'>
        <div className="HelloText">
          <span className='HelloTextSpan'>
            {text}
          </span>
          <Cursor/>
        </div>
        <h1 className="HomeName">I'm Karthikeya</h1>
        <span className='HomeDesc'>Student @<a href='https://www.iitbbs.ac.in/' target="_blank" rel="noopener noreferrer">IIT Bhubaneswar</a></span>
        <br/>
        <div className='KnowmorebuttonContainer'>
        <a href="#about" className='KnowMore'> Know more</a>
        </div>
        </div>
      </div>
    </div>
  );
}
